import request from '../utils/request';
//params => get
//data => POST

//banner
export const getBanner = params => {
    return request({
        url: `/admin/index/list/${params}`,
        method: 'get',
    });
};
//训练营学科介绍
export const getCourseList = params => {
    return request({
        url: '/training_camp/course_introduction/list',
        method: 'post',
        data:params
    });
};
//训练营学科介绍项目实战列表
export const getprojectList = params => {
    return request({
        url: `/training_camp/course_introduction/project/list/${params}`,
        method: 'get',
    });
};
//训练营学科介绍问题解答---如何确定自己适合学Java
export const getprojectQuestionList = languageType => {
    return request({
        url: `/training_camp/course_introduction/project/question/${languageType}`,
        method: 'get',
    });
};
//训练营学科课程安排阶段列表
export const getprojectPhaseList = (languageType,professionalDirection) => {
    return request({
        url: `/training_camp/course_introduction/project/phase/${languageType}/${professionalDirection}`,
        method: 'get',
    });
};
//训练营根据阶段id获取学科详细数据
export const getprojectPhaseTextList = params => {
    return request({
        url: `/training_camp/course_introduction/project/phase/text/${params}`,
        method: 'get',
    });
};

//训练营-报名流程
export const getRegistrationProcess = type => {
    return request({
        url: `/training_camp/course_introduction/registration_process/${type}`,
        method: 'get',
    });
};
//报名流程-开班情况
export const getClassCondition= (languageType) => {
    return request({
        url: `/training_camp/course_introduction/class_condition/${languageType}`,
        method: 'get',
    });
};
//报名流程-费用构成数据列表
export const getExpenseInfo = (languageType) => {
    return request({
        url: `/training_camp/course_introduction/expense_info/${languageType}`,
        method: 'get',
    });
};
//报名流程-学习环境数据
export const getLearningEnvironment = () => {
    return request({
        url: `/training_camp/course_introduction/learning_environment`,
        method: 'get',
    });
};
//训练营介绍-报名入读须知详情
export const getCampNotice = () => {
    return request({
        url: '/admin/title/info',
        method: 'get',
    });
};
//作业下载列表
export const getWorkFile = () => {
    return request({
        url:'/admin/task-url/list',
        method: 'post',
    });
};